import { BALANCE_UPDATED, BALANCE_CHANGED, USER_UPDATED, USER_FIRST_LOG_IN_UPDATED, TRACKING_LOGOUT, USER_JURISDICTION_QUERY } from '@gig/magic-messages';
import { magic } from '@gig/magic-sdk';
import { Currency } from '@gig/magic-sdk/dist/adapter/users/signup';

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
class TrackingService {
  constructor(trackingService) {
    this.trackingService = trackingService;
    this.trackBalanceChanges();
    this.trackUserChanges();
    this.setJurisdiction();
  }
  trackBalanceChanges() {
    window.eventBus.subscribe(BALANCE_UPDATED, (event) => {
      var _a;
      const balance = (_a = event.payload) != null ? _a : null;
      this.trackingService.setBalance(balance);
    });
    window.eventBus.subscribe(BALANCE_CHANGED, (event) => {
      var _a;
      const balance = (_a = event.payload) != null ? _a : null;
      if (balance) {
        this.trackBalanceChange(balance);
      }
    });
  }
  trackUserChanges() {
    window.eventBus.subscribe(USER_UPDATED, (e) => {
      if (e.payload !== null) {
        this.trackingService.setUser(e.payload);
        this.trackingService.trackLogin();
      } else {
        this.trackingService.setUserAccounts([]);
      }
    });
    window.eventBus.subscribe(USER_FIRST_LOG_IN_UPDATED, (e) => {
      if (!!e.payload) {
        this.trackingService.trackFirstLogin();
      }
    });
    window.eventBus.subscribe(TRACKING_LOGOUT, (e) => {
      this.trackingService.trackLogout(e.payload);
    });
  }
  trackBalanceChange({ balance }) {
    const user = magic.session.getUser();
    if (!user) {
      return;
    }
    if (balance === 0) {
      this.trackingService.trackBalanceZero();
    } else if (balance < this.getLowBalanceLimit(user)) {
      this.trackingService.trackBalanceNearZero();
    }
  }
  setJurisdiction() {
    return __async(this, null, function* () {
      const currentJurisdiction = yield window.queryBus.query(USER_JURISDICTION_QUERY);
      this.trackingService.setJurisdiction(currentJurisdiction);
    });
  }
  getLowBalanceLimit(user) {
    if ([Currency.SEK, Currency.NOK].includes(user.currency)) {
      return 50;
    }
    return 5;
  }
}

export { TrackingService };
